import { Collapse } from 'antd';
import EfSpec from 'elem/ui/ef-spec';
import { useRouter } from 'next/router';
import { RuleTabModuleIdEnum } from '../Tab';
import css from './index.module.scss';
import { useLang } from '@/i18n';

export default function PageComp() {
    const { locale } = useRouter();
    const { t } = useLang('rule');

    const HighlightEmails = (text: string) => {
        const emailRegex = /([\w.-]+@[\w-]+\.[\w.-]+)/g;
        const parts = text.split(emailRegex);
        const highlightedText = parts.map((part, index) => {
            if (emailRegex.test(part)) {
                return (
                    <i className="email-link" key={index}>
                        {part}
                    </i>
                );
            }
            return part;
        });
        return <>{highlightedText}</>;
    };
    const list = [
        {
            title: t('F_list_title1'),
            desc: t('F_list_desc1'),
        },
        {
            title: t('F_list_title2'),
            desc: t('F_list_desc2'),
        },
        {
            title: t('F_list_title3'),
            desc: t('F_list_desc3'),
        },
        {
            title: t('F_list_title4'),
            desc: t('F_list_desc4'),
        },
        {
            title: t('F_list_title5'),
            desc: t('F_list_desc5'),
        },
        {
            title: t('F_list_title6'),
            desc: t('F_list_desc6'),
        },
    ];

    return (
        <div className={`${css['page-comp']}`} id={RuleTabModuleIdEnum.FrequentlyAskedQuestions}>
            <EfSpec />
            <p className="title">{t('F_title')}</p>
            <Collapse className={`F_collapse_list ${locale}`} ghost expandIconPosition="right">
                {list.map((i, idx) => (
                    <Collapse.Panel header={i.title} key={idx}>
                        {HighlightEmails(i.desc)}
                    </Collapse.Panel>
                ))}
            </Collapse>
            <EfSpec />
        </div>
    );
}
